import type { Dialect } from './types'

/** Renders one logical table namespace for the target SQL dialect. */
export function tableSqlRef(
  tableName: string,
  schema: string | undefined,
  dialect: Dialect,
): string {
  if (!schema) return quoteIdentifier(tableName)
  if (dialect === 'sqlite') return quoteIdentifier(`${schema}_${tableName}`)
  if (dialect === 'snowflake') return `${schema}.${quoteIdentifier(tableName)}`
  return `${quoteIdentifier(schema)}.${quoteIdentifier(tableName)}`
}

/** Physical table name, without SQL qualification or quoting. */
export function physicalTableName(
  tableName: string,
  schema: string | undefined,
  dialect: Dialect,
): string {
  return schema && dialect === 'sqlite' ? `${schema}_${tableName}` : tableName
}

export function quoteIdentifier(name: string): string {
  return `"${name.replaceAll('"', '""')}"`
}
